import { statistic } from "@core/store/modules/webmaster/dashboard/statistic";

export const dashboard = {
  namespaced: true,
  modules: {
    statistic
  }
};
